/*from-zero-to-turbo*/
/*more-guides*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "创建你的仓库",
  "description": "设计和构建你的 Turborepo。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "构建单一仓库是一个谨慎的过程。通过这些指南，你将学习如何设计和构建一个能够提升每个团队效率的单一仓库 (monorepo)。 - 无论大小。"
  }, {
    "heading": "",
    "content": "¥Architecting a monorepo is a careful process. Through these guides, you'll learn how to design and build a monorepo that will make every team faster - no matter the size."
  }, {
    "heading": "",
    "content": "本节中的指南将指导你构建一个多包工作区，通常称为 monorepo。由于它们建立在之前指南的知识之上，因此建议按顺序阅读，但你可以按任意顺序阅读，或跳至与你的用例相关的页面。"
  }, {
    "heading": "",
    "content": "¥The guides in this section will take you through building a multi-package workspace, commonly referred to as a monorepo. They are meant to be read in order as they build on top of the knowledge from previous guides, but you can read them in any order or skip to the pages specific to your use case."
  }, {
    "heading": "",
    "content": "读完本节所有内容后，你应该已经很好地理解了如何使用 Turborepo 设计和构建单一仓库。"
  }, {
    "heading": "",
    "content": "¥By the time you've read through all of this section, you should have a good understanding of how to design and build a monorepo with Turborepo."
  }, {
    "heading": "",
    "content": "Turborepo 还可用于加速单包工作区。访问 单包工作区 部分了解更多信息。"
  }, {
    "heading": "",
    "content": "¥Turborepo can also be used to speed up single-package workspaces. Visit the\nsingle-package workspace section for\nmore information."
  }, {
    "heading": "从零到-turbo-from-zero-to-turbo",
    "content": "¥From zero to turbo"
  }, {
    "heading": "更多指南-more-guides",
    "content": "¥More guides"
  }, {
    "heading": "更多指南-more-guides",
    "content": "我们还有更多围绕 特定工具、用例和其他主题 的指南。"
  }, {
    "heading": "更多指南-more-guides",
    "content": "¥We also have more guides centered around specific tools, use cases, and other topics."
  }],
  "headings": [{
    "id": "从零到-turbo-from-zero-to-turbo",
    "content": "从零到 turbo /*from-zero-to-turbo*/"
  }, {
    "id": "更多指南-more-guides",
    "content": "更多指南 /*more-guides*/"
  }]
};
import {Card, Cards} from '#components/card';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#从零到-turbo-from-zero-to-turbo",
  title: _jsxs(_Fragment, {
    children: ["从零到 ", _jsx("code", {
      children: "turbo"
    }), " "]
  })
}, {
  depth: 2,
  url: "#更多指南-more-guides",
  title: _jsx(_Fragment, {
    children: "更多指南 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "构建单一仓库是一个谨慎的过程。通过这些指南，你将学习如何设计和构建一个能够提升每个团队效率的单一仓库 (monorepo)。 - 无论大小。"
    }), "\n", _jsx(_components.p, {
      children: "¥Architecting a monorepo is a careful process. Through these guides, you'll learn how to design and build a monorepo that will make every team faster - no matter the size."
    }), "\n", _jsx(_components.p, {
      children: "本节中的指南将指导你构建一个多包工作区，通常称为 monorepo。由于它们建立在之前指南的知识之上，因此建议按顺序阅读，但你可以按任意顺序阅读，或跳至与你的用例相关的页面。"
    }), "\n", _jsx(_components.p, {
      children: "¥The guides in this section will take you through building a multi-package workspace, commonly referred to as a monorepo. They are meant to be read in order as they build on top of the knowledge from previous guides, but you can read them in any order or skip to the pages specific to your use case."
    }), "\n", _jsx(_components.p, {
      children: "读完本节所有内容后，你应该已经很好地理解了如何使用 Turborepo 设计和构建单一仓库。"
    }), "\n", _jsx(_components.p, {
      children: "¥By the time you've read through all of this section, you should have a good understanding of how to design and build a monorepo with Turborepo."
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["Turborepo 还可用于加速单包工作区。访问 ", _jsx(_components.a, {
          href: "/docs/guides/single-package-workspaces",
          children: "单包工作区"
        }), " 部分了解更多信息。"]
      }), _jsxs(_components.p, {
        children: ["¥Turborepo can also be used to speed up single-package workspaces. Visit the\n", _jsx(_components.a, {
          href: "/docs/guides/single-package-workspaces",
          children: "single-package workspace"
        }), " section for\nmore information."]
      })]
    }), "\n", _jsxs(_components.h2, {
      id: "从零到-turbo-from-zero-to-turbo",
      children: ["从零到 ", _jsx(_components.code, {
        children: "turbo"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥From zero to ", _jsx(_components.code, {
        children: "turbo"
      })]
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        href: "/docs/crafting-your-repository/structuring-a-repository",
        title: "1. Structuring a repository",
        description: "Design the directory structure of your monorepo."
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/managing-dependencies",
        title: "2. Managing dependencies",
        description: "Using dependencies for sharing code"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/creating-an-internal-package",
        title: "3. Creating an internal package",
        description: "Make a package in your repository"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/configuring-tasks",
        title: "4. Configuring tasks",
        description: "Design your task patterns"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/running-tasks",
        title: "5. Running tasks",
        description: "Run tasks as fast as possible"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/caching",
        title: "6. Caching",
        description: "Never do the same work twice"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/developing-applications",
        title: "7. Developing apps",
        description: "Run many apps in parallel"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/using-environment-variables",
        title: "8. Using environment variables",
        description: "Account for variables in your environment"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/constructing-ci",
        title: "9. Constructing CI",
        description: "Ship your applications"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/upgrading",
        title: "10. Upgrading",
        description: "Upgrading your Turborepo version"
      }), _jsx(Card, {
        href: "/docs/crafting-your-repository/understanding-your-repository",
        title: "11. Understanding your repository",
        description: "Understanding your codebase with Turborepo"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "更多指南-more-guides",
      children: "更多指南 "
    }), "\n", _jsx(_components.p, {
      children: "¥More guides"
    }), "\n", _jsxs(_components.p, {
      children: ["我们还有更多围绕 ", _jsx(_components.a, {
        href: "/docs/guides",
        children: "特定工具、用例和其他主题"
      }), " 的指南。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥We also have more guides centered around ", _jsx(_components.a, {
        href: "/docs/guides",
        children: "specific tools, use cases, and other topics"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
